var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hardwareContainer"},_vm._l((_vm.hardwareData),function(item,i){return _c('img',{key:i,staticClass:"img_scale",attrs:{"src":item.img}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }